<template>
    <div class="grid grid-fixed" :style="{width: columnWidth + 'px',top: top + 'px' ,bottom:options.page ?'44px': '0px'}" v-show="showFixedGrid">
        <div class="grid-header">
            <grid-header
                ref="header"
                :propColumns="propOptions.columns"
                :propFill="options.fill"
                :propWidth="columnWidth"
                :propFilter="options.filter"
                :propFilterOpen="options.filterOpen"
                :propColumnResize="options.columnResize"
                :propEditorInvisible="options.editorInvisible"
                :allChecked="allChecked"
                :propFixedColumn="true"
                @allCheck="(allChecked)=>{this.allChecked=allChecked;this.checkboxClickFn();}"
                @changeWidth="val => this.headerWidth=val"
                @filterClose="()=>{this.grid.options.filterOpen=false}"
                @sortListGrid="sortGrid"
            ></grid-header>
        </div>

        <div class="grid-body" v-show="options.showBody" ref="fixedVs">
            <table :style="{width:columnWidth}">
                <thead>
                        <template v-for="(item,index) in propOptions.columns">
                            <th
                                :key="index"
                                :style="{width:item.width+'px'}"
                                v-if="getFieldVisible(item)"
                            ></th>
                        </template>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(row,rowIndex) in fixedData"
                            :key="row.id || rowIndex"
                            @click="rowActive($event,rowIndex,row)"
                            @mouseup="checkboxClickFn(row)"
                            :data-index="rowIndex"
                            :row-group-index="row._groupIndex"
                            :parent-group-index="row._parentGroupIndex"
                            :class="{
                                expand:row._expand,
                                'row-group':row._groupRow,
                                hidden:row._hidden,
                                hide:row.show === false
                            }"
                            :ref="'row-'+row.id"
                            :style="getRowStyle(row)"
                        >
                            <td
                                v-if="row._groupRow"
                                class="body-cell body-cell-group"
                                :colspan="columns.length"
                            >
                                <div class="switch" @click="switchRowGroup(row)">
                                    <roundAddImg
                                        v-if="!row._expand"
                                        v-bind="{color: '#007aff',width:'16px',height:'16px'}"
                                    />
                                    <roundMinusImg
                                        v-if="row._expand"
                                        v-bind="{color: '#007aff',width:'16px',height:'16px'}"
                                    />
                                </div>
                                <div v-html="getRowGroupFormatter(row)"></div>
                            </td>
                            <template v-else v-for="(field,cellIndex) in propOptions.columns">
                                <td
                                    v-if="getFieldVisible(field)"
                                    :style="cellStyleFormatter(field,row)"
                                    :key="cellIndex"
                                >
                                    <template v-if="field.editor && renderEditor(field,row)">
                                        <div class="body-cell">
                                            <cellEditor
                                                :options="field"
                                                :row="row"
                                                :rowIndex="rowIndex"
                                                :cellIndex="cellIndex"
                                                :ref="rowIndex +'_'+field.field"
                                            />
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div
                                            v-if="field.checkbox"
                                            class="body-cell select-row-checkbox-cell"
                                        >
                                            <checkbox
                                                :ref="'checkbox_'+rowIndex"
                                                :propChecked="allChecked || row._checked"
                                                :propValue="rowIndex"
                                                @change="rowCheckedChange"
                                                :key="row.id + rowIndex"
                                                v-if="options.type !== 'treeGrid'"
                                            ></checkbox>
                                        </div>
                                        <div
                                            v-else-if="field.radio"
                                            class="body-cell select-row-radio-cell"
                                        >
                                            <radio
                                                :ref="'checkbox_'+rowIndex"
                                                :propChecked="allChecked || row._checked"
                                                :propValue="rowIndex"
                                                @change="rowRadioChange"
                                                v-if="options.type !== 'treeGrid'"
                                            ></radio>
                                        </div>
                                        <div
                                            v-else-if="field.index"
                                            class="body-cell row-index-cell"
                                        >{{rowIndex + 1}}</div>
                                        <div v-else-if="field.type==='link'" class="body-cell">
                                            <a
                                                href="javascript:"
                                                @click="cellClick(field.field,row,rowIndex)"
                                                v-html="getFieldValue(row, field.field)"
                                            ></a>
                                        </div>
                                        <!--下拉框类型显示值-->
                                        <div v-else-if="field.type==='select'" class="body-cell">
                                            <div
                                                class="readonly-text"
                                                v-html="getSelectText(field,row,rowIndex)"
                                            ></div>
                                        </div>
                                        <!--checkbox类型显示值-->
                                        <div v-else-if="field.type==='checkbox'" class="body-cell">
                                            <div
                                                class="readonly-text"
                                                v-html="getCheckboxText(field,row,rowIndex)"
                                            ></div>
                                        </div>
                                        <div v-else-if="field.type==='richText'" class="body-cell">
                                            <richTextField
                                                class="readonly-text"
                                                :propReadonly="true"
                                                :options="{field:field}"
                                                :propValue="row[field.field]"
                                                :rowIndex="rowIndex"
                                            ></richTextField>
                                        </div>
                                        <!-- 电子签名 -->
                                        <div v-else-if="field.type==='sign'" class="body-cell">
                                            <signField
                                                :propValue="getFieldValue(row, field.field)"
                                                :options="{field:field}"
                                                :propReadonly="true"
                                            ></signField>
                                        </div>
                                        <!--simpleCheckbox-->
                                        <div
                                            v-else-if="field.type==='simpleCheckbox'"
                                            class="body-cell"
                                        >
                                            <simple-checkbox-field
                                                :propValue="getFieldValue(row, field.field)"
                                                :options="{field:field}"
                                                :propReadonly="true"
                                            />
                                        </div>
                                        <!--treeGrid字段类型-->
                                        <div v-else-if="field.type==='tree'" class="body-cell">
                                            <treeGridNode
                                                :ref="'node_'+ rowIndex"
                                                v-bind="{row,single:options.single,fieldOptions:field,rowIndex,checkedNodes}"
                                                @change="nodeClickHandle"
                                                v-if="options.type === 'treeGrid'"
                                            ></treeGridNode>
                                        </div>
                                        <div v-else class="body-cell" :field="field.field">
                                            <div
                                                class="cell-icon"
                                                v-if="field.iconFormatter"
                                                :class="field.iconFormatter(row)"
                                            ></div>
                                            <cellTagField
                                                v-else-if="field.tagFormatter"
                                                :options="field.tagFormatter(row)"
                                            ></cellTagField>
                                            <div
                                                v-else
                                                class="readonly-text"
                                                :title="getReadonlyTitle(rowIndex,field,row)"
                                                v-html="getReadonlyText(rowIndex,field,row)"
                                            ></div>
                                        </div>
                                    </template>
                                </td>
                            </template>
                        </tr>
                        <tr v-if="(!fixedData || fixedData.length===0) && loading===false">
                            <td class="no-record-cell" :colspan="propOptions.columns.length">
                                <div class="no-record body-cell">
                                    <div class="no-record-div">
                                        <img
                                            class="no-record-img"
                                            src="../../../../img/no-record.png"
                                        />
                                        <span class="no-record-text">暂无数据</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import Gikam from "../../../core/gikam-core";
import genericQueryPanel from "./gridGeneralQueryPanel.vue";
import gridHeader from "./fixedHeader";
import treeGridNode from "./treeGridNode.vue";
import Vue from "vue";
import jQuery from "jquery";
import cellEditor from "./cellEditor";
export default {
    props: {
        options: Object,
        scrollTop: {
            default: 0,
            type: Number
        },
        scrollLeft: {
            default: 0,
            type: Number
        },
        propFilterOpen: Boolean
    },

    inject: {
        grid: {
            default: null
        }
    },

    computed: {
        height() {
            if (this.options.fill) {
                return "100%";
            }
            const height = this.options.height;
            return Gikam.isNumber(height) ? height + "px" : height;
        },

        width() {
            return this.headerWidth + "px";
        },

        maxRow() {
            return this.options.data.length - 1;
        },

        maxCol() {
            return this.options.columns.length - 1;
        },

        cellLineFeed() {
            return this.options.textLineFeed;
        },

        allColumns() {
            return this.$store.state.columns;
        },

        fixedData() {
            return this.options.data;
        }
    },

    provide() {
        return {
            checkedNodes: this.checkedNodes
        };
    },

    methods: {
        getColumnTitle(field) {
            return Gikam.propI18N(field.title);
        },

        getRowGroupFormatter(row) {
            return this.options.group.formatter.call(this.grid, row);
        },

        switchRowGroup(row) {
            row._expand = !row._expand;
            this.options.data
                .filter(subRow => {
                    return subRow._parentGroupIndex === row._groupIndex;
                })
                .forEach(item => {
                    item._hidden = !row._expand;
                });
        },

        getReadonlyText(rowIndex, field, row) {
            if (field.formatter) {
                return field.formatter(
                    rowIndex,
                    Gikam.getFieldValue(row, field.field),
                    row
                );
            } else {
                return Gikam.getFieldValue(row, field.field);
            }
        },

        getReadonlyTitle(rowIndex, field, row) {
            let title = this.getReadonlyText(rowIndex, field, row);
            return Gikam.isNotEmpty(title)
                ? (title + "").replace(/<\/?[a-zA-Z]+[^><]*>/g, "")
                : "";
        },

        getFieldValue(data, field) {
            return Gikam.getFieldValue(data, field);
        },

        rowCheckedChange(checked, rowIndex, event) {
            event && event.stopPropagation();
            const row = this.options.data[rowIndex];
            if (checked) {
                this.checkeds.push(rowIndex);
                this.checkeds.sort((a, b) => {
                    return a - b;
                });
                this.grid.trigger("select", row);
            } else {
                this.checkeds.splice(this.checkeds.indexOf(rowIndex), 1);
                this.grid.trigger("unSelect", row);
            }
            this.checkboxClickFn();
        },

        rowRadioChange(checked, rowIndex, event) {
            let checkedRowIndex = this.checkeds[0];
            if (Gikam.isNotEmpty(checkedRowIndex)) {
                this.$refs["checkbox_" + checkedRowIndex][0].checked = false;
                this.checkeds.length = 0;
            }
            this.rowCheckedChange(checked, rowIndex, event);
        },

        nodeClickHandle(checked, single, row) {
            this.$set(row, "checked", checked);
            this.grid.trigger("nodeSelected", row, checked);
            if (single) {
                if (checked) {
                    this.options.data
                        .filter(item => item.checked)
                        .forEach(item => {
                            this.$set(item, "checked", false);
                            this.grid.trigger("nodeSelected", item, false);
                        });
                    this.$set(row, "checked", true);
                }
            } else {
                const childrenRow = this.getAllChildren(row, []);
                if (Gikam.isNotEmpty(childrenRow)) {
                    childrenRow.forEach(_row => {
                        this.$set(_row, "checked", checked);
                        this.grid.trigger("nodeSelected", _row, checked);
                    });
                }
            }
        },

        checkboxClickFn() {
            this.$nextTick(() => {
                this.grid.trigger("checkboxClick");
            });
        },

        getSelections() {
            return this.checkeds.map(rowIndex =>
                Gikam.deepExtend(this.options.data[rowIndex])
            );
        },

        getSelectText(field, item, rowIndex) {
            let selectText = null;
            let value = Gikam.getFieldValue(item, field.field);
            Gikam.each(field.items, function() {
                if (this.value === value) {
                    selectText = this.text;
                    return false;
                }
            });
            return field.formatter
                ? field.formatter(rowIndex, value, item, selectText)
                : selectText;
        },

        cellClick(field, row, rowIndex) {
            setTimeout(() => {
                const position = this.$refs["vs"].getPosition();
                Gikam.getInstance(
                    jQuery(this.$el).closest(".window")
                ).model.storage = {
                    grid: this.grid,
                    index: rowIndex,
                    scroll: {
                        top: position.scrollTop,
                        left: position.scrollLeft
                    }
                };
                this.grid.trigger(
                    "cellClick",
                    field,
                    Gikam.deepExtend(row),
                    rowIndex
                );
            }, 0);
        },

        rowActive(event, index, rowData) {
            if (this.options.type === "treeGrid") {
                const checked = this.options.data[index].checked;
                this.$refs["node_" + index][0].changeHandle(!checked);
            } else {
                if (this.options.checkOneOnActive) {
                    Gikam.extend(true, [], this.checkeds).forEach(index => {
                        this.$refs["checkbox_" + index][0].clickHandle();
                    });
                }
                if (this.options.checkOnActive) {
                    const checkbox = this.$refs["checkbox_" + index];
                    checkbox && checkbox[0].clickHandle();
                }
            }
            //激活的是当前行，此时不再进行激活
            if (this.activeRow && this.activeRow !== event.currentTarget) {
                this.activeRow.classList.remove("active");
            }
            if (this.activeRow !== event.currentTarget) {
                this.grid.trigger("rowActive", index, rowData);
            }
            this.activeRow = event.currentTarget;
            this.activeRowData = rowData;
            this.activeRow.classList.add("active");
        },

        getActiveRow() {
            if (this.activeRowData) {
                let row = Gikam.deepExtend(this.activeRowData);
                row.index = ~~this.activeRow.getAttribute("data-index");
                return row;
            } else {
                return null;
            }
        },

        clean() {
            this.checkeds = [];
            this.checkedNodes = [];
            this.activeRow = null;
            this.activeRowData = null;
            this.allChecked = false;
        },

        //上方工具栏查询
        initCompoSearch() {
            if (Gikam.isEmpty(this.options.toolbar)) {
                return;
            }
            let _this = this;
            let formOptions = this.options.toolbar.filter(item => {
                return item.type === "form";
            })[0];
            if (Gikam.isEmpty(formOptions)) {
                return;
            }
            formOptions.fields.forEach(item => {
                let change = item.onChange;
                item.onChange = function() {
                    _this.grid.refresh({
                        requestData: this.getData()
                    });
                    change && change.call(form);
                };
            });
            let toolbarItem = jQuery('<div class="item"></div>').appendTo(
                this.$el.querySelector(".search")
            );
            formOptions.renderTo = toolbarItem[0];
            let form = Gikam.create("form", formOptions);
        },

        setFieldsReadonly(index, fields, isReadonly) {
            for (let key in this.$refs) {
                if (
                    this.$refs[key].options &&
                    fields.indexOf(this.$refs[key].options.field) > -1 &&
                    parseInt(key.split("_")[0]) === index
                ) {
                    this.$refs[key].readonly = isReadonly;
                }
            }
        },

        renderEditor(field, row) {
            if (field.onBeforeEditorRender) {
                return field.onBeforeEditorRender.call(this.grid, row);
            } else {
                return true;
            }
        },

        genericQueryReset() {
            const requestData = this.grid.options.requestData;
            this.options.genericQueryFields.forEach(item => {
                for (let key in requestData) {
                    if (key.indexOf(item.field) >= 0) {
                        delete requestData[key];
                    }
                }
            });
            this.options.genericQueryFields = this.defaultGenericQueryFields;
            this.grid.refresh();
        },

        popGenericQueryPanel() {
            if (this.activeGenericQuery) {
                return;
            }
            this.genericQueryCount = this.options.genericQueryFields.length;
            const $searchBtn = jQuery(
                this.$el.querySelector(".generic-query-btn")
            );
            const left = $searchBtn.offset().left + "px";
            const top =
                $searchBtn.offset().top + $searchBtn.outerHeight() + 2 + "px";
            const _this = this;
            this.activeGenericQuery = new Vue({
                el: jQuery(
                    '<generic-query-Panel :options="options" @change="changeHandle" @destroy="destroyHandle"/>'
                ).appendTo("body")[0],
                provide: {
                    grid: this.grid
                },
                components: { genericQueryPanel },
                methods: {
                    changeHandle(conditions) {
                        _this.genericQueryCount = conditions.length;
                    },
                    destroyHandle() {
                        _this.activeGenericQuery = void 0;
                    }
                },
                data() {
                    return {
                        options: {
                            left: left,
                            top: top,
                            fields: _this.options.columns.filter(
                                item => item.field
                            ),
                            genericQueryFields: _this.options.genericQueryFields
                        }
                    };
                }
            });
        },

        cellStyleFormatter(fieldOptions, row) {
            if (fieldOptions.styleFormatter) {
                return fieldOptions.styleFormatter(row);
            }
        },

        getRowStyle(row) {
            if (this.options.rowStyleFormatter) {
                return this.options.rowStyleFormatter(row);
            }
        },

        getAllChildren(row, result) {
            const _this = this;
            if (row.children) {
                row.children.forEach(item => {
                    if (item.children) {
                        _this.getAllChildren(item, result);
                    }
                    result.push(item);
                });
            }
            return result;
        },

        inputCursorMovement(rowIndex, columnIndex, direction) {
            //处理边界情况
            if (columnIndex < 0 && rowIndex < 0) {
                this.inputCursorMovement(this.maxRow, this.maxCol, direction);
                return;
            } else if (columnIndex > this.maxCol && rowIndex > this.maxRow) {
                this.inputCursorMovement(0, 0, direction);
                return;
            } else if (columnIndex < 0) {
                this.inputCursorMovement(rowIndex - 1, this.maxCol, direction);
                return;
            } else if (rowIndex < 0) {
                this.inputCursorMovement(
                    this.maxRow,
                    columnIndex - 1,
                    direction
                );
                return;
            } else if (columnIndex > this.maxCol) {
                this.inputCursorMovement(rowIndex + 1, 0, direction);
                return;
            } else if (rowIndex > this.maxRow) {
                this.inputCursorMovement(0, columnIndex + 1, direction);
                return;
            }

            const nextTextInput = this.$refs[rowIndex + "_" + columnIndex];
            //处理能否获取光标情况
            if (nextTextInput && nextTextInput.$options.name === "textInput") {
                nextTextInput.focus();
            } else {
                switch (direction) {
                    case "left":
                        this.inputCursorMovement(
                            rowIndex,
                            columnIndex - 1,
                            direction
                        );
                        break;
                    case "up":
                        this.inputCursorMovement(
                            rowIndex - 1,
                            columnIndex - 1,
                            direction
                        );
                        break;
                    case "right":
                        this.inputCursorMovement(
                            rowIndex,
                            columnIndex + 1,
                            direction
                        );
                        break;
                    case "down":
                        this.inputCursorMovement(
                            rowIndex + 1,
                            columnIndex,
                            direction
                        );
                        break;
                    default:
                        return;
                }
            }
        },

        // 排序
        sortGrid(orderField, orderType) {
            if (!orderType || !orderField) {
                delete this.grid.options.order[this.grid.options.orderField];
                this.grid.refresh();
                return;
            }

            if (this.grid.options.orderField === orderField) {
                this.grid.options.order[orderField] = orderType;
            } else {
                delete this.grid.options.order[this.grid.options.orderField];
                this.grid.options.order[orderField] = orderType;
                this.grid.options.orderField = orderField;
            }
            this.grid.refresh();
        },

        getCheckedNodeRow() {
            return this.checkedNodes.map(item => item.row);
        },

        getFieldVisible(options) {
            if (options.visible === undefined || options.visible === "1") {
                return true;
            }
            return false;
        },

        fixColumns(scrollLeft) {
            //需要固定的总宽度
            let width = 0;
            //配置固定列的field
            let columns = [];
            this.fixedWidth = [];
            Gikam.extend(true, this.fixedOptions, this.options);
            this.propOptions.columns = this.allColumns.filter(
                item => {
                    if (item.fixed == true) {
                        columns.push(item.field);
                        let temp = 0;
                        if (this.fixedWidth.length) {
                            temp = this.fixedWidth.reduce((prev, current) => {
                                return prev + current;
                            });
                        }
                        this.fixedWidth.push(width - temp);
                    }
                    width += item.width;
                    return item.fixed == true;
                }
            );

            let showNum = 0;
            for (let i = this.fixedWidth.length; i > 0; i--) {
                if (this.fixedWidth[i - 1] <= scrollLeft - 1) {
                    showNum = Math.max(showNum, i);
                }
            }

            if (showNum) {
                this.showFixedGrid = true;
            } else {
                this.showFixedGrid = false;
                return;
            }
            this.propOptions.columns = this.propOptions.columns.filter(
                (item, i) => i < showNum
            );
            this.columnWidth = 0;
            this.propOptions.columns.forEach(item => {
                this.columnWidth += item.width;
            });

            this.$nextTick(() => {
                this.top = this.$refs.fixedVs.parentElement.parentElement.firstChild.offsetHeight + 8;
            })
        }
    },

    watch: {
        allChecked() {
            if (this.allChecked === true) {
                const checkedIndex = [];
                for (let i = 0; i < this.options.data.length; i++) {
                    checkedIndex.push(i);
                }
                this.checkeds = checkedIndex;
            } else {
                this.checkeds = [];
            }
            this.grid.trigger("allCheck", this.allChecked);
        },

        scrollTop(val) {
            this.$refs.fixedVs && (this.$refs.fixedVs.scrollTop = val);
        },

        scrollLeft(val, oldVal) {
            if (Math.abs(val - oldVal) < 5) return;
            this.fixColumns(-val);
        }
    },

    data() {
        return {
            Gikam: Gikam,
            allChecked: false,
            checkeds: [],
            checkedNodes: [],
            selectedRow: [],
            loading: false,
            activeRow: null,
            activeRowData: null,
            genericQueryCount: 0,
            activeGenericQuery: void 0,
            defaultGenericQueryFields: Gikam.extend(
                true,
                [],
                this.options.genericQueryFields
            ),
            pageNum: this.options.pageNum,
            headerWidth: this.options.width,
            showFixedColumns: false,
            editorInvisible: this.options.editorInvisible,
            showFixedGrid: false,
            fixedOptions: {},
            propOptions: {
                columns: []
            },
            top: 0,
            columnWidth: 0,
            fixedWidth: [],
        };
    },

    components: {
        gridHeader,
        treeGridNode,
        cellEditor,
        cellTagField: {
            props: {
                options: {
                    type: Object,
                    default: () => {
                        return {
                            type: "",
                            value: ""
                        };
                    }
                }
            },
            template:
                '<div class="cell-tag" :class="options.type"><div class="cell-tag-text">{{options.value}}</div></div>'
        }
    }
};
</script>

<style>
.grid {
    height: 100%;
    background-color: white;
    padding: 8px;
    display: flex;
    flex-direction: column;
    position: relative;
}

.grid > .toolbar {
    padding-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.grid > .toolbar > .operation {
    flex: 1;
    display: flex;
    justify-content: flex-end;
}
.grid > .toolbar > .search {
    display: flex;
}

.grid > .toolbar > .search > .filter-dropdown-btn > .text {
    white-space: nowrap;
}

.search > .item > .form > .panel {
    margin: 0;
}

.grid > .toolbar > .search > .item > .form .form-group .title {
    width: auto;
    padding-left: 16px;
}

.grid > .toolbar > .search > .item > .form .form-group {
    margin: 0;
    width: auto !important;
}

/*解决IE下toobar下formField跑版问题*/
.grid > .toolbar > .search > .item > .form .form-group .field {
    flex: none;
}

.search > .item > .form > .panel .text-input,
.search > .item > .form > .panel .select {
    height: 24px;
    width: 200px;
    min-height: 24px;
}

.search > .item > .form > .panel .select div,
.search > .item > .form > .panel .text-input div,
.search > .item > .form > .panel .text-input input {
    min-height: 24px;
    display: flex;
    align-items: center;
}

.search > .item > .form {
    padding: 0;
}

.grid > .grid-header {
    border: 1px solid #eee;
    border-bottom: none;
    overflow: hidden;
    box-shadow: 0 2px 3.6px 0.4px rgba(0, 0, 0, 0.06);
    z-index: 1;
    background-color: #fff;
}

.grid > .grid-body {
    border: 1px solid #eee;
    flex: 1;
    overflow: auto;
    height: 0;
    border-top: none;
}

.grid > .grid-body table {
    border-collapse: collapse;
    border-spacing: 0;
    table-layout: fixed;
}

.grid > .grid-body table > thead th {
    height: 0;
    padding: 0;
    border: none;
}

.grid > .grid-body table > tbody > tr {
    transition: transform 0.2s ease-out;
}

.grid > .grid-body table > tbody > .hide {
    float: left;
    visibility: hidden;
    transform: translateY(-100%);
    height: 0;
}

.grid > .grid-body table > tbody > tr > td {
    height: 32px;
    padding: 0;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
    text-align: left;
    border-right: 1px solid #eee;
}

.grid > .grid-body table > tbody > tr > td:last-child {
    border-right: none;
}

.grid > .grid-body .body-cell.select-row-checkbox-cell,
.grid > .grid-body .body-cell.select-row-radio-cell,
.grid > .grid-body .body-cell.row-index-cell {
    display: flex;
    justify-content: center;
}

.grid > .grid-body table > tbody > tr:nth-child(odd) {
    background-color: rgba(11, 184, 148, 0.05);
}

.grid > .grid-body table > tbody > tr > .no-record-cell {
    background-color: #fff;
}

.grid > .grid-body table > tbody > tr > td > .body-cell a {
    text-decoration: none;
    color: #007aff;
    height: auto;
}

.grid > .grid-body table > tbody > tr > td > .body-cell {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 8px;
    white-space: nowrap;
}

.grid > .grid-body table > tbody > tr > td > .body-cell p {
    margin: 0;
}

.grid > .grid-body table > tbody > tr > td > .body-cell > .cell-icon {
    width: 25px;
    height: 25px;
}

.grid
    > .grid-body
    table
    > tbody
    > tr
    > td
    > .body-cell
    > .cell-tag
    > .cell-tag-text {
    height: 24px;
    line-height: 23px;
    padding: 0 8px;
    border-radius: 4px;
}

.grid
    > .grid-body
    table
    > tbody
    > tr
    > td
    > .body-cell
    > .cell-tag.success
    > .cell-tag-text {
    color: #00d94d;
    background-color: #e5fbed;
    border: 1px solid #66e894;
}

.grid
    > .grid-body
    table
    > tbody
    > tr
    > td
    > .body-cell
    > .cell-tag.danger
    > .cell-tag-text {
    color: #ff3b30;
    background-color: #ffe2e0;
    border: 1px solid #ff8983;
}

.grid
    > .grid-body
    table
    > tbody
    > tr
    > td
    > .body-cell
    > .cell-tag.info
    > .cell-tag-text {
    color: #007aff;
    background-color: #e5f1ff;
    border: 1px solid #66afff;
}

.grid
    > .grid-body
    table
    > tbody
    > tr
    > td
    > .body-cell
    > .cell-tag.warning
    > .cell-tag-text {
    color: #ffba00;
    background-color: #fff8e5;
    border: 1px solid #ffd666;
}

.grid
    > .grid-body
    table
    > tbody
    > tr
    > td
    > .body-cell:not(.select-row-checkbox-cell):not(.select-row-radio-cell)
    > * {
    padding: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 24px;
    line-height: 24px;
}

.grid > .grid-body table > tbody > tr > td > .body-cell .simple-checkbox {
    display: flex;
    justify-content: center;
}

.grid > .grid-body table > tbody > tr > td > .body-cell > .readonly-text {
    width: 100%;
}

.grid
    > .grid-body
    table
    > tbody
    > tr
    > td
    > .body-cell
    .select
    .select-container
    .placeholder {
    font-size: 12px;
}

.grid > .grid-body table > tbody > tr > td > .body-cell.no-record {
    height: 78px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
}

.grid
    > .grid-body
    table
    > tbody
    > tr
    > td
    > .body-cell.no-record
    > .no-record-div {
    box-sizing: content-box;
    padding: 0 0 5px 0;
    height: 70px;
}

.grid
    > .grid-body
    table
    > tbody
    > tr
    > td
    > .body-cell
    > .no-record-div
    > .no-record-img {
    display: block;
}

.grid
    > .grid-body
    table
    > tbody
    > tr
    > td
    > .body-cell
    > .no-record-div
    > .no-record-text {
    display: block;
    margin-top: -10px;
}
.grid > .grid-body table > tbody > tr:last-child {
    border-bottom: 1px solid #eee;
}
.grid > .grid-footer {
    height: 36px;
    display: flex;
    align-items: center;
    position: relative;
    border: 1px solid #eee;
    border-top: none;
    padding-bottom: 2px;
}

.grid > .grid-footer > .grid-page-toolbar {
    width: 100%;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(0, 0, 0, 0.65);
    font-size: 12px;
}

.grid > .grid-footer > .grid-page-toolbar > .button {
    border: none;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center;
}

.grid > .grid-footer > .grid-page-toolbar > .page-num-input {
    width: 42px;
    height: 24px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    text-align: center;
    color: #666;
    margin-right: 12px;
    margin-left: 13px;
    font-size: 12px;
}

.grid > .grid-footer > .grid-page-toolbar > .page-num-input:focus {
    border: 1px solid rgba(0, 122, 255, 0.5);
}

.grid > .grid-footer > .grid-page-toolbar > .total-record {
    color: rgba(0, 0, 0, 0.45);
    margin-left: 16px;
}

.grid > .grid-footer > .grid-page-toolbar > .select {
    width: 100px;
    height: 24px;
    padding: 0;
    margin-left: 21px;
    margin-left: 12px;
}

.grid > .grid-footer > .grid-page-toolbar > .total-pages {
    margin-right: 10px;
}

.grid > .grid-footer > .grid-page-toolbar > .button.disabled {
    opacity: 0.3;
    pointer-events: none;
}

.grid > .grid-footer > .grid-page-toolbar > .button.last-page,
.grid > .grid-footer > .grid-page-toolbar > .button.next-page {
    width: 20px;
    height: 24px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.grid > .grid-footer > .grid-footer-toolbar {
    position: absolute;
    right: 28px;
    display: flex;
    align-items: center;
}

.grid > .grid-footer > .grid-footer-toolbar > .item {
    width: 20px;
    height: 20px;
    background-position: center;
    background-repeat: no-repeat;
    margin-left: 8px;
    cursor: pointer;
}

.grid > .toolbar > .item.dropDownMenuMore {
    margin-left: 8px;
}

.grid .item.dropDownMenuMore {
    order: 1;
}

.grid > .custom-content {
    color: rgba(0, 0, 0, 0.65);
    width: 100%;
    font-size: 14px;
}

.grid > .grid-body table > tbody > tr:hover {
    background-color: rgba(11, 184, 148, 0.08);
}

.grid > .grid-body table > tbody > tr.active {
    background-color: rgba(0, 122, 255, 0.16);
}

.grid > .toolbar > .search > .generic-query-btn {
    display: flex;
    align-items: center;
    height: 24px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    padding: 0 0 0 9px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
    width: 150px;
    justify-content: space-between;
    cursor: pointer;
    margin-right: 10px;
}

.grid > .toolbar > .search > .filter-dropdown-btn > .text {
    white-space: nowrap;
}

.grid > .toolbar > .search > .generic-query-btn.active {
    border: 1px solid rgba(0, 122, 255, 0.5);
}

.grid > .toolbar > .search > .generic-query-btn > .drop {
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: space-between;
}

.grid > .toolbar > .search > .generic-query-btn > .drop > .search-icon {
    width: 12px;
    height: 12px;
    background: url(../../../../img/grid-generic-query.png) no-repeat center;
}

.grid > .toolbar > .search > .generic-query-btn > .refresh-icon {
    width: 34px;
    height: 100%;
    background: url(../../../../img/grid-generic-refresh.png) no-repeat center;
    border-left: 1px solid #d9d9d9;
}

.grid > .toolbar > .search > .generic-query-btn > .refresh-icon.active {
    background: url(../../../../img/grid-generic-refresh-blue.png) no-repeat
        center;
}

.grid > .toolbar > .search > .generic-query-btn > .drop > .down-arrow {
    width: 28px;
    height: 12px;
    background: url(../../../../img/grid-generic-query-down-arrow.png) no-repeat
        center;
}

.grid .row-group > .body-cell-group > .switch {
    height: 100%;
    width: 30px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

.grid [parent-group-index].hidden {
    display: none;
}

.grid.grid-fixed {
    position: absolute;
    left: 0;
    padding: 0 !important;
    height: auto;
}

.grid-fixed .grid-body {
    overflow: hidden;
}

.__rail-is-horizontal {
    z-index: 2 !important;
}

</style>